"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBase = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("../../utils/i18n");
const ModalBase = ({ title, text, close, showFooter, messageType, dialogStyles, children }) => {
    return (react_1.default.createElement("div", { className: "modal", role: "dialog", style: dialogStyles, onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { className: "modal-content", style: messageType.content },
            react_1.default.createElement("div", { className: "modal-header", style: Object.assign({ paddingTop: "0px" }, messageType.header) },
                react_1.default.createElement("div", { className: "modal-title" },
                    react_1.default.createElement("button", { className: "icon--cross close", autoFocus: true, onClick: close, "aria-label": (0, i18n_1.text)('popup.close') }),
                    react_1.default.createElement("h3", { style: messageType.titleText }, title))),
            react_1.default.createElement("div", { className: "modal-body" }, text),
            showFooter && (react_1.default.createElement("div", { className: "modal-footer" }, children)))));
};
exports.ModalBase = ModalBase;
